<template>
  <div ref="secretaryPlayer">
    <b-row align-h="center" align-v="center" :class="secretaryPlayerHeight" class="mt-md-5 mt-lg-5 mt-xl-5 mt-1">
      <b-col cols="12" class="text-center">
        <b-row>
          <b-col v-if="$i18n.locale=='en'">
            <h1 style="    margin-top: 44px;">{{ titleEn }}</h1>
            <h3>{{ subTitleEn }}</h3>
          </b-col>
          <b-col v-if="$i18n.locale=='es'">
            <h1 style="    margin-top: 44px;">{{ titleEs }}</h1>
            <h3>{{ subTitleEs }}</h3>
          </b-col>
          <b-col v-if="$i18n.locale=='cat'">
            <h1 style="    margin-top: 44px;">{{ titleCat }}</h1>
            <h3>{{ subTitleCat }}</h3>
          </b-col>
        </b-row>
        <!--<b-row>
          <b-col>
            <h5><span>{{ $t('playerSpanTotalUsers') }} </span> {{ count }}</h5>
          </b-col>
        </b-row>-->
        <b-row align-h="center">
          <b-col v-if="isChatActivated" cols="15" align-self="center">
            <button v-on:click="exportCSVFile" class="btn btn-secondary">{{ $t('playerBtnDownloadCsv') }}
            </button>
          </b-col>
        </b-row>

      </b-col>
      <b-col cols="8" sm="8" md="4" lg="4" xl="4" align-self="center"
             class="shadowPlayer pl-0 pr-0   mr-5" v-if="isIframe && !isPosterEndImage && !isActivePanicPoster">
        <b-embed v-if="$i18n.locale==='en'"
                 type="iframe"
                 aspect="16by9"
                 :src="playerUrl"
                 allowfullscreen
                 autoplay
        >
        </b-embed>
        <b-embed v-if="$i18n.locale==='es'"
                 autoplay
                 type="iframe"
                 aspect="16by9"
                 :src="playerUrlEs"
                 allowfullscreen>
        </b-embed>
        <b-embed v-if="$i18n.locale==='cat'"
                 autoplay
                 type="iframe"
                 aspect="16by9"
                 :src="playerUrlCat"
                 allowfullscreen>
        </b-embed>
      </b-col>
      <b-col>
        <b-img v-if="isActivePanicPoster" fluid :src="panicPoster"></b-img>
      </b-col>
      <b-col v-if="!isIframe && !isPosterEndImage && !isActivePanicPoster" cols="8" sm="8" md="4" lg="4" xl="4"
             align-self="center"
             class="pl-0 pr-0   mr-5">
        <b-img v-if="$i18n.locale==='en'" fluid :src="posterStartEn"></b-img>
        <b-img v-if="$i18n.locale==='es'" fluid-grow :src="posterStartEs"></b-img>
        <b-img v-if="$i18n.locale==='cat'" fluid :src="posterStartCat"></b-img>
      </b-col>
      <b-col v-if="isPosterEndImage && !isIframe && !isActivePanicPoster" cols="8" sm="8" md="4" lg="4" xl="4"
             align-self="center"
             class="pl-0 pr-0   mr-5">
        <b-img v-if="$i18n.locale==='en'" fluid :src="posterEndEn"></b-img>
        <b-img v-if="$i18n.locale==='es'" fluid-grow :src="posterEndEs"></b-img>
        <b-img v-if="$i18n.locale==='cat'" fluid :src="posterEndCat"></b-img>
      </b-col>
      <b-col cols="10" sm="10" md="7" lg="7" xl="7" class="mt-md-5 mt-sm-5"
             align-self="center">
        <b-card no-body class="shadowChat">
          <b-card-header header-tag="nav">
            <b-nav card-header tabs>
              <b-nav-item class="navItem" :active="tabIndex===0" v-on:click="linkClass(0)">
                Chat General
                <b-badge>{{ countNewMsgGeneral === 0 ? '' : countNewMsgGeneral }}</b-badge>
              </b-nav-item>
              <b-nav-item class="navItem" :active="tabIndex===1"
                          v-on:click="linkClass(1)">
                Chat Periodistas
                <b-badge>{{ countNewMsgPer === 0 ? '' : countNewMsgPer }}</b-badge>
              </b-nav-item>
              <b-nav-item class="navItem" :active="tabIndex===2"
                          v-on:click="linkClass(2)">
                {{ $t('moderatorWebinarTabChatLabel') }}
                <b-badge>{{ countNewMsgModerator === 0 ? '' : countNewMsgModerator }}</b-badge>
              </b-nav-item>
              <b-nav-item v-if="areQuestionsActive" class="navItem" :active="tabIndex===2"
                          v-on:click="linkClass(3)">
                {{ $t('secretaryTabQuestions') }}
              </b-nav-item>
            </b-nav>
          </b-card-header>
          <b-card-body class="text-center">
            <div v-if="isChatActivated && tabIndex===0" id="conversation-panel" class="conversation-panel"
                 style="height: 30vh;">
              <div style="cursor: pointer" v-on:click="showModal(message)"
                   v-bind:style=" message.filtered ? 'background: #38ab79;' : message.answered? 'background: #5f579A ': ''"
                   class="message" v-for="(message, index) in newMessages" v-bind:key="index">
                <b>
                  {{ message.name }}
                </b>
                <br>
                {{ message.msg }}
              </div>
            </div>
            <!-- Chat de los periodistas -->
            <div v-if="isChatActivated && tabIndex===1" id="conversation-panel-perdiodistes" class="conversation-panel"
                 style="height: 30vh;">
              <div style="cursor: pointer" v-on:click="showModal(message)"
                   v-bind:style=" message.filtered ? 'background: #38ab79;' : message.answered? 'background: #5f579A ': ''"
                   class="message" v-for="(message, index) in periodistesMessages" v-bind:key="index">
                <b>
                  {{ message.name }} ({{ message.company }})
                </b>
                <br>
                {{ message.msg }}
              </div>
            </div>
            <!-- Moderator -->
            <div v-if="isChatActivated && tabIndex===2">
              <div id="conversation-panel-moderator"
                   class="conversation-panel"
                   style="height: 30vh;">
                <div v-on:click="showModal(message)"
                     v-bind:style=" message.filtered ? 'background: #38ab79;' : ''"
                     class="message" v-for="(message, index) in moderatorMessages"
                     v-bind:key="index">
                  <b>
                    {{ message.name }}
                  </b>
                  <br>
                  {{ message.msg }}
                </div>
              </div>
              <b-row align-h="end">
                <b-col cols="12" sm="9" md="9" lg="8" xl="9">
                  <b-textarea v-model="messageSend.msg" v-on:keyup.enter="sendMessage">

                  </b-textarea>
                </b-col>
                <b-col align-self="center" class="mt-md-2 mt-2 mt-lg-0 mt-xl-0" cols="12" sm="3"
                       md="3"
                       lg="3" xl="3">
                  <b-button variant="light" v-on:click="sendMessage">
                    {{ $t('playerBtnSendMessage') }}
                  </b-button>
                </b-col>
              </b-row>
            </div>
            <div v-if="tabIndex===3 && areQuestionsActive">
              <div class="conversation-panel"
                   style="height: 30vh;"
                   v-if="$i18n.locale=='en'">
                <div class="message" v-for="(item, index) in questionsEn" v-bind:key="index">
                  <b-row>
                    <b-col cols="6">
                      {{ index + 1 }} {{ item.question }}

                    </b-col>
                    <b-col>
                      <b-button variant="light" v-on:click="showAnswers(item)">
                        {{ $t('secretaryShowAnswers') }}
                      </b-button>
                    </b-col>
                    <b-col>
                      <b-button v-if="!item.sended" variant="light"
                                v-on:click="showTimerModal(index)">
                        {{ $t('secretarySendQuestion') }}
                      </b-button>
                      <b-button v-else variant="light">
                        {{ $t('secretaryQuestionSended') }}
                      </b-button>
                    </b-col>
                  </b-row>
                </div>
              </div>
              <div class="conversation-panel"
                   style="height: 30vh;"
                   v-if="$i18n.locale=='es'">
                <div class="message" v-for="(item, index) in questionsEs" v-bind:key="index">
                  <b-row>
                    <b-col cols="6">
                      {{ index + 1 }} {{ item.question }}

                    </b-col>
                    <b-col>
                      <b-button variant="light" v-on:click="showAnswers(item)">
                        {{ $t('secretaryShowAnswers') }}
                      </b-button>
                    </b-col>
                    <b-col>
                      <b-button v-if="!item.sended" variant="light"
                                v-on:click="showTimerModal(index)">
                        {{ $t('secretarySendQuestion') }}
                      </b-button>
                      <b-button v-else variant="light">
                        {{ $t('secretaryQuestionSended') }}
                      </b-button>
                    </b-col>
                  </b-row>
                </div>
              </div>
              <div class="conversation-panel"
                   style="height: 30vh;"
                   v-if="$i18n.locale=='cat'">
                <div class="message" v-for="(item, index) in questionsCat" v-bind:key="index">
                  <b-row>
                    <b-col cols="6">
                      {{ index + 1 }} {{ item.question }}

                    </b-col>
                    <b-col>
                      <b-button variant="light" v-on:click="showAnswers(item)">
                        {{ $t('secretaryShowAnswers') }}
                      </b-button>
                    </b-col>
                    <b-col>
                      <b-button v-if="!item.sended" variant="light"
                                v-on:click="showTimerModal(index)">
                        {{ $t('secretarySendQuestion') }}
                      </b-button>
                      <b-button v-else variant="light">
                        {{ $t('secretaryQuestionSended') }}
                      </b-button>
                    </b-col>
                  </b-row>
                </div>
              </div>
              <b-button class="form-control" target="_blank" to="/dashboard">
                {{ $t('secretaryShowGraphs') }}
              </b-button>
            </div>
          </b-card-body>
        </b-card>

      </b-col>
      <!--Modal-->
      <b-modal id="modal-prevent-closing" centered :title="$t('secretaryOptionsChatModalTitle')" hide-footer
               @hidden="hideModal">
        <label>{{ selectedMsg.name }}</label>: <label>{{ selectedMsg.msg }}</label>
        <b-row>
          <b-col v-if="!isResponseUser">
            <b-button v-on:click="showAlertModal(toModerator=true)" variant="light">
              {{ $t('secretaryBtnSendModerator') }}

            </b-button>
          </b-col>
          <b-col>
            <b-button variant="light" v-on:click="isResponseUser = true" v-if="!isResponseUser">
              {{ $t('secretaryBtnSendResponseUser') }}
            </b-button>
            <b-textarea v-if="isResponseUser" v-model="messageSend.msg"
                        v-on:keyup.enter="showAlertModal(toModerator=false)"></b-textarea>
            <b-button class="mt-3" v-on:click="showAlertModal(toModerator=false)" v-if="isResponseUser">
              {{ $t('secretaryBtnSendOk') }}
            </b-button>
          </b-col>
        </b-row>
      </b-modal>
      <b-modal id="modal-multi-2" size="sm" :title="$t('secretaryOptionsChatModalAlertTitle')" hide-footer>
        <b-row>
          <b-col>
            <b-button v-on:click="sendResponse" variant="light">
              {{ $t('secretaryBtnSendOk') }}

            </b-button>
          </b-col>
          <b-col>
            <b-button variant="light" v-on:click="hideAllModals">
              {{ $t('secretaryBtnSendCancel') }}
            </b-button>
          </b-col>
        </b-row>
      </b-modal>
    </b-row>

    <b-modal @hidden="hideModalAnswers" id="modal-center" centered :title="questionTitle" hide-footer>
      <b-list-group v-for="(item, index)  in questionAnswers" v-bind:key="index" class="flex-column">
        <b-row>
          <b-col>
            <b-list-group-item>{{ item.answerLetter }}</b-list-group-item>

          </b-col>
          <b-col cols="10">
            <b-list-group-item>{{ item.answer }}</b-list-group-item>

          </b-col>
        </b-row>
      </b-list-group>
    </b-modal>
    <b-modal id="timerModal" centered title="Tiempo de Respuesta">
      <b-row>
        <b-col align-self="center">
          <label>{{ $t('secretaryInputSeconds') }}:</label>
        </b-col>
        <b-col cols="5">
          <b-form-input v-model="questionTimer" v-on:keyup.enter="sendQuestion" type="number"></b-form-input>
        </b-col>
      </b-row>
      <template #modal-footer>

        <b-button variant="light" v-on:click="sendQuestion"
        >
          {{ $t('secretarySendQuestion') }}
        </b-button>
        <b-button variant="light" v-on:click="$bvModal.hide('timerModal')"
        >
          {{ $t('secretaryBtnSendCancel') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import app from "../firebaseConfig/config";
import 'firebase/database'
import {mapState} from 'vuex'

export default {
  name: "secretaryPlayer",
  data: () => {
    return {
      chat: false,
      messageSend: {
        name: '',
        msg: '',
        date: '',
        email: '',
        company: ''
      },
      newMessages: [],
      periodistesMessages: [],
      activeClass: 'background: #f5f5f5;',
      count: 0,
      isUpdated: false,
      numSameEmail: 0,
      userVerified: 0,
      titleEn: '',
      subTitleEn: '',
      titleEs: '',
      subTitleEs: '',
      titleCat: '',
      subTitleCat: '',
      chatsRef: '',
      usersRef: '',
      secretaryPlayerHeight: 'secretaryPlayerHeight',
      chatsModeratorRef: '',
      isGeneralActive: true,
      isModalVerified: false,
      selectedMsg: '',
      isResponseUser: false,
      toModerator: false,
      moderatorMessages: [],
      code: '',
      tabIndex: 0,
      questionsEn: '',
      questionsEs: '',
      questionsCat: '',
      questionTitle: '',
      questionAnswers: '',
      questionTimer: 0,
      questionIndex: '',
      isIframe: false,
      isPosterEndImage: false,
      isActivePanicPoster: false,
      areQuestionsActive: false,
      countNewMsgGeneral: 0,
      countNewMsgPer: 0,
      countNewMsgModerator: 0,
    }
  },
  computed: {
    ...mapState(['isChatActivated', 'playerUrl', 'playerUrlEs', 'playerUrlCat', 'posterStartEn', 'posterStartEs', 'posterStartCat', 'posterEndEn', 'posterEndEs', 'posterEndCat', 'panicPoster'])
  },
  methods: {
    /**
     * active or deactivate tabs
     * @param idx
     */
    linkClass(idx) {
      this.tabIndex = idx
      switch (idx) {
        case 0:
          this.countNewMsgGeneral = 0;
          setTimeout(function () {
            const conversationPanel = document.getElementById('conversation-panel');
            conversationPanel.scrollTop = conversationPanel.clientHeight;
            conversationPanel.scrollTop = conversationPanel.scrollHeight - conversationPanel.scrollTop;
          }, 50)
          break;
        case 1:
          this.countNewMsgPer = 0;
          setTimeout(function () {
            const conversationPanelPer = document.getElementById('conversation-panel-perdiodistes');
            conversationPanelPer.scrollTop = conversationPanelPer.clientHeight;
            conversationPanelPer.scrollTop = conversationPanelPer.scrollHeight - conversationPanelPer.scrollTop;
          }, 50)
          break;
        case 2:
          this.countNewMsgModerator = 0;
          setTimeout(function () {
            const conversationPanel = document.getElementById('conversation-panel-moderator');
            conversationPanel.scrollTop = conversationPanel.clientHeight;
            conversationPanel.scrollTop = conversationPanel.scrollHeight - conversationPanel.scrollTop;
          }, 50)
          break;
      }
    },
    /**
     * Send msg to moderator
     */
    sendMessage() {
      //function to push message to firebase and if you are not admin inserts in chat
      const d = new Date;
      this.messageSend.date = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds()
      this.messageSend.date = this.messageSend.date.toString()
      if (this.messageSend.msg[this.messageSend.msg.length - 1] === '\n') {
        this.messageSend.msg = this.messageSend.msg.slice(0, -1)
      }
      this.chatsModeratorRef.push(this.messageSend)
      this.messageSend.msg = ''
      this.messageSend.date = ''
      setTimeout(function () {
        const conversationPanel = document.getElementById('conversation-panel');
        const conversationPanelPer = document.getElementById('conversation-panel-perdiodistes');
        conversationPanel.scrollTop = conversationPanel.clientHeight;
        conversationPanel.scrollTop = conversationPanel.scrollHeight - conversationPanel.scrollTop;
        conversationPanelPer.scrollTop = conversationPanelPer.clientHeight;
        conversationPanelPer.scrollTop = conversationPanelPer.scrollHeight - conversationPanelPer.scrollTop;
      }, 100)
    },
    /**
     * Get cookie passed by param
     * @param cname
     * @returns {string}
     */
    getCookie(cname) {
      //function that passes the key of the cookie to obtain the value
      const name = cname + "=";
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    /**
     * Delete cookie passed by param
     * @param name
     */
    deleteCookie(name) {
      document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },
    /**
     * Add 1 user every time is called of total users
     */
    userAdded() {
      this.count++
    },
    /**
     * Remove one user every time is called of total users
     */
    userDisconnected() {
      this.count--
    },
    /**
     * Function that parses json into string for make CSV
     * @param objArray
     * @returns {string}
     */
    convertToCSV(objArray) {
      const array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
      let str = "";
      for (let i = 0; i < array.length; i++) {
        let line = "";
        for (const index in array[i]) {
          if (line != "") line += ",";
          line += array[i][index];
        }
        str += line + "\r\n";
      }
      return str;
    },
    /**
     * Function called for export Chat into CSV file
     */
    exportCSVFile() {
      const headers = {
        name: this.$i18n.t('adminTitleCSVFileName').toString(),
        email: this.$i18n.t('adminTitleCSVFileEmail').toString(),
        company: this.$i18n.t('loginLabelCompany').toString().replace(':',''),
        msg: "Pregunta/Comentario",
        date: this.$i18n.t('adminTitleCSVFileDate').toString(),
      };
      const fileName = (new Date()).toDateString()
      const data = []
      for (let i = 0; i < this.newMessages.length; i++) {
        if (this.newMessages[i].name) {
          data.push({
            name: this.newMessages[i].name,
            email: 'None',
            company: 'None',
            msg: this.newMessages[i].msg.replace(/[.,\s]/g, ' '),
            date: this.newMessages[i].date
          })
        }
      }
      for (let x = 0; x < this.periodistesMessages.length; x++) {
        data.push({
          name: this.periodistesMessages[x].name,
          email: this.periodistesMessages[x].email,
          company: this.periodistesMessages[x].company,
          msg: this.periodistesMessages[x].msg.replace(/[.,\s]/g, ' '),
          date: this.periodistesMessages[x].date
        })
      }
      if (headers) {
        data.unshift(headers);
      }
      const jsonObject = JSON.stringify(data);
      const csv = this.convertToCSV(jsonObject)
      const exportName = fileName + ".csv" || "export.csv";
      const blob = new Blob([csv], {type: "text/csv;charset=utf-8;"});
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, exportName);
      } else {
        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", exportName);
          link.setAttribute("target", "_blank");
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
    /**
     * Show modal to decide if filter msg to moderator or response to user
     * @param user
     */
    showModal(user) {
      this.selectedMsg = user
      this.$bvModal.show('modal-prevent-closing')
    },
    /**
     * Hide modal to decide if filter msg to moderator or response to user
     */
    hideModal() {
      this.$bvModal.hide('modal-prevent-closing')
      this.isResponseUser = false
    },
    /**
     * Show Modal to confirm the decision taken
     */
    showAlertModal() {
      this.$bvModal.show('modal-multi-2')
    },
    /**
     * Hide all active modals
     */
    hideAllModals() {
      this.$bvModal.hide('modal-multi-2')
      this.hideModal()
    },
    /**
     * Function to response  user question for only that user
     */
    responseUser() {
      const regex = /[.,&·#$€\s]/g;
      const result = this.selectedMsg.email.replace(regex, '') ? this.selectedMsg.email.replace(regex, '') : this.selectedMsg.id.replace(regex, '');
      const userChat = app.database().ref(`lallucana/${this.code}/chat/${result}`)
      if (this.messageSend.msg[this.messageSend.msg.length - 1] === '\n') {
        this.messageSend.msg = this.messageSend.msg.slice(0, -1)
      }
      userChat.push(this.messageSend)
      this.newMessages.map((msg) => msg === this.selectedMsg ? msg.answered = true : null)
      this.periodistesMessages.map((msg) => msg === this.selectedMsg ? msg.answered = true : null)
      const msgUpdate = this.selectedMsg
      const code = this.code
      this.chatsRef.orderByChild('date').equalTo(this.selectedMsg.date).once('value', function (snapshot) {
        snapshot.forEach(function (childSnapshot) {
          const key = childSnapshot.key
          const childData = childSnapshot.val();
          if (msgUpdate.id === childData.id && msgUpdate.msg === childData.msg) {
            const updateMessageRef = app.database().ref(`lallucana/${code}/msg/${key}`)
            updateMessageRef.update(msgUpdate)
          }
        });
      })
      this.periodistesRef.orderByChild('date').equalTo(this.selectedMsg.date).once('value', function (snapshot) {
        snapshot.forEach(function (childSnapshot) {
          const key = childSnapshot.key
          const childData = childSnapshot.val();
          if (msgUpdate.email === childData.email && msgUpdate.msg === childData.msg) {
            const updateMessageRef = app.database().ref(`lallucana/${code}/periodistes/${key}`)
            updateMessageRef.update(msgUpdate)
          }
        });
      })
      this.messageSend.msg = ''
    },
    /**
     * Decides if response to user or send question to moderator
     */
    sendResponse() {
      !this.toModerator ? this.responseUser() : this.filterToModerator()
      this.hideAllModals()
    },
    /**
     * Function to update firebase filtered question state and push filtered question to moderator
     */
    filterToModerator() {
      const filterToModeratorRef = app.database().ref(`lallucana/${this.code}/filterModerator`)
      this.newMessages.map((msg) => msg === this.selectedMsg ? msg.filtered = true : null)
      this.periodistesMessages.map((msg) => msg === this.selectedMsg ? msg.filtered = true : null)
      const msgUpdate = this.selectedMsg
      const code = this.code
      this.chatsRef.orderByChild('date').equalTo(this.selectedMsg.date).once('value', function (snapshot) {
        snapshot.forEach(function (childSnapshot) {
          const key = childSnapshot.key
          const childData = childSnapshot.val();
          if (msgUpdate.name === childData.name && msgUpdate.msg === childData.msg) {
            const updateMessageRef = app.database().ref(`lallucana/${code}/msg/${key}`)
            updateMessageRef.update(msgUpdate)
          }
        });
      })
      this.periodistesRef.orderByChild('date').equalTo(this.selectedMsg.date).once('value', function (snapshot) {
        snapshot.forEach(function (childSnapshot) {
          const key = childSnapshot.key
          const childData = childSnapshot.val();
          if (msgUpdate.email === childData.email && msgUpdate.msg === childData.msg) {
            const updateMessageRef = app.database().ref(`lallucana/${code}/periodistes/${key}`)
            updateMessageRef.update(msgUpdate)
          }
        });
      })
      filterToModeratorRef.push(this.selectedMsg)
    },
    /**
     * Get questions of specific event
     */
    getQuestions() {
      this.questionsEn = JSON.parse(localStorage.getItem('eventQuestionsEn'))
      this.questionsEs = JSON.parse(localStorage.getItem('eventQuestionsEs'))
      this.questionsCat = JSON.parse(localStorage.getItem('eventQuestionsCat'))
    },
    /**
     * Show  answers passed by param in a modal
     * @param item
     */
    showAnswers(item) {
      this.questionTitle = item.question
      this.questionAnswers = item.answers
      this.$bvModal.show('modal-center')
    },
    /**
     * Hide Answer modal
     */
    hideModalAnswers() {
      this.$bvModal.hide('modal-center')
    },
    /**
     * Send question to users
     * @param question
     */
    async sendQuestion() {
      const index = this.questionIndex
      const questionsRef = app.database().ref(`lallucana/${this.code}/questions`)
      const newQuestion = {
        en: this.questionsEn[index],
        es: this.questionsEs[index],
        cat: this.questionsCat[index],
        response: index,
        timer: this.questionTimer
      }
      questionsRef.push(newQuestion)
      setTimeout(() => {
        try {
          questionsRef.remove()
        } catch (e) {
          console.log(e.message)
        }
      }, 10000)
      /*   this.questionsCat.map((q) => q.question === this.questionsCat[index].question ? q.sended = true : null)
          this.questionsEs.map((q) => q.question === this.questionsEs[index].question ? q.sended = true : null)
          this.questionsEn.map((q) => q.question === this.questionsEn[index].question ? q.sended = true : null)
          this.$set(this.questionsEn)
          this.$set(this.questionsEs)
          this.$set(this.questionsCat)
          localStorage.setItem('eventQuestionsEn', JSON.stringify(this.questionsEn))
          localStorage.setItem('eventQuestionsEs', JSON.stringify(this.questionsEs))
          localStorage.setItem('eventQuestionsCat', JSON.stringify(this.questionsCat))
          const eventId = Cryptr.AES.decrypt(this.getCookie('eventId'), 'secret key 1234').toString(Cryptr.enc.Utf8)
          const event = {
              event: {
                  questionsEn: this.questionsEn,
                  questionsEs: this.questionsEs,
                  questionsCat: this.questionsCat,
                  id: eventId
              },
              email: this.getCookie('email')
          }
          try {
              const accessToken = await app.auth().currentUser.getIdToken(true)
              await apiService.modifyEvent(accessToken, event)
          }catch (e) {
              console.log(e.message)
          }*/
      this.$bvModal.hide('timerModal')
    },
    showTimerModal(index) {
      this.questionIndex = index
      this.$bvModal.show('timerModal')
    },
    checkStatusIframe(snapshot) {
      snapshot.forEach((childSnapshot) => {
        const childData = childSnapshot.val();
        this.isIframe = childData
      });
    },
    checkStatusPosterEnd(snapshot) {
      snapshot.forEach((childSnapshot) => {
        const childData = childSnapshot.val();
        this.isPosterEndImage = childData
      });
    },
    /**
     * Check Panic Poster status when admin connects to manage event
     * @param snapshot
     * */
    checkStatusPanicPoster(snapshot) {
      snapshot.forEach((childSnapshot) => {
        const childData = childSnapshot.val();
        this.isActivePanicPoster = childData
      });
    },
    /**
     * Verify Height of user widow for make page more responsive
     */
    matchHeight() {
      const totalComponentsHeight = this.$refs.secretaryPlayer.clientHeight + 80 + 100
      document.documentElement.clientHeight <= 890 ? this.secretaryPlayerHeight = 'min-vh-100' : this.secretaryPlayerHeight = 'secretaryPlayerHeight'
      if (totalComponentsHeight < document.documentElement.clientHeight) {
        if (this.footerClass !== 'footer' && !this.$route.path.includes('events')) this.$store.commit('updateFooterClass', 'footer')
      } else {
        if (this.footerClass !== 'footerRelative') this.$store.commit('updateFooterClass', 'footerRelative')
      }
    },
  },
  created() {
    try {
      this.code = this.$route.params.id && this.$route.path.includes('player') ? this.$route.params.id.toLowerCase().replace(/\s/g, "") : localStorage.getItem('code')
      this.periodistesRef = app.database().ref(`lallucana/${this.code}/periodistes`)
      this.chatsRef = app.database().ref(`lallucana/${this.code}/msg`)
      this.chatsModeratorRef = app.database().ref(`lallucana/${this.code}/moderator/msg`)
      this.getQuestions()
      //deleteAdminCookie
      this.deleteCookie('adminUser')

      this.titleEn = localStorage.getItem('webinarTitleEn')
      this.titleEs = localStorage.getItem('webinarTitleEs')
      this.titleCat = localStorage.getItem('webinarTitleCat')
      this.subTitle = localStorage.getItem('webinarSubTitle')
      this.subTitleEs = localStorage.getItem('webinarSubTitleEs')
      this.subTitleCat = localStorage.getItem('webinarSubTitleCat')
      this.areQuestionsActive = localStorage.getItem('areQuestionsActive') === 'true'

      if (!this.playerUrl) this.$store.commit('updatePlayerUrl', localStorage.getItem('playerUrlEn'))
      if (!this.playerUrlEs) this.$store.commit('updatePlayerUrlEs', localStorage.getItem('playerUrlEs'))
      if (!this.playerUrlCat) this.$store.commit('updatePlayerUrlCat', localStorage.getItem('playerUrlCat'))
      if (!this.posterStartEn) this.$store.commit('updatePosterStartEn', localStorage.getItem('posterStartEn'))
      if (!this.posterEndEn) this.$store.commit('updatePosterEndEn', localStorage.getItem('posterEndEn'))
      if (!this.posterStartEs) this.$store.commit('updatePosterStartEs', localStorage.getItem('posterStartEs'))
      if (!this.posterEndEs) this.$store.commit('updatePosterEndEs', localStorage.getItem('posterEndEs'))
      if (!this.posterStartCat) this.$store.commit('updatePosterStartCat', localStorage.getItem('posterStartCat'))
      if (!this.posterEndCat) this.$store.commit('updatePosterEndCat', localStorage.getItem('posterEndCat'))
      this.messageSend.name = this.getCookie('name')
      this.messageSend.email = this.getCookie('email')
    } catch (e) {
      console.log(e)
      this.$router.push({path: '/'})
    }
    //Verify is cookie exist or not
    if (!document.cookie) {
      this.$router.push({path: '/'})
    } else {
      this.messageSend.name = this.getCookie('name')
      this.messageSend.email = this.getCookie('email')
    }
  },
  mounted() {
    this.matchHeight()
    window.addEventListener("resize", this.matchHeight);
    //Count total users connected in the conference
    // eslint-disable-next-line no-unused-vars
    // this.usersRef.on("child_added", this.userAdded)
    // this.usersRef.on("child_removed", this.userDisconnected)
    //function for receive the new messages added in firebase
    const newMessages = this.newMessages;
    this.chatsRef.on("child_added", (snapshot) => {
      const newPost = snapshot.val();
      newMessages.push({
        name: newPost.name,
        email: newPost.email,
        msg: newPost.msg,
        date: newPost.date,
        filtered: newPost.filtered,
        company: newPost.company,
        answered: newPost.answered,
        id: newPost.id
      })
      if (this.tabIndex!==0) this.countNewMsgGeneral++
      //There's a delay between firebase and user, that's why I execute this setTimeput
      setTimeout(() => {
        try {
          const conversationPanel = document.getElementById('conversation-panel');
          conversationPanel.scrollTop = conversationPanel.clientHeight;
          conversationPanel.scrollTop = conversationPanel.scrollHeight - conversationPanel.scrollTop;
        } catch (e) {
          console.log()
        }
      }, 200)
    });
    //Funcion para coger los mensajes de los periodistas
    const periodistesMessages = this.periodistesMessages;
    this.periodistesRef.on("child_added", (snapshot) => {
      const newPost = snapshot.val();
      periodistesMessages.push({
        name: newPost.name,
        email: newPost.email,
        msg: newPost.msg,
        date: newPost.date,
        filtered: newPost.filtered,
        company: newPost.company,
        answered: newPost.answered,
        id: newPost.id
      })
      if (this.tabIndex!==1) this.countNewMsgPer++

      //There's a delay between firebase and user, that's why I execute this setTimeput
      setTimeout(() => {
        try {
          const conversationPanelPer = document.getElementById('conversation-panel-perdiodistes');
          conversationPanelPer.scrollTop = conversationPanelPer.clientHeight;
          conversationPanelPer.scrollTop = conversationPanelPer.scrollHeight - conversationPanelPer.scrollTop;
        } catch (e) {
          console.log()
        }
      }, 200)
    });
    //function for receive the new messages added in firebase from moderator or to moderator
    const moderatorMessages = this.moderatorMessages;
    this.chatsModeratorRef.on("child_added", (snapshot) => {
      const newPost = snapshot.val();
      moderatorMessages.push({
        name: newPost.name,
        email: newPost.email,
        msg: newPost.msg,
        date: newPost.date,
        company: newPost.company
      })
      if (this.tabIndex!==2) this.countNewMsgModerator++
      //There's a delay between firebase and user, that's why I execute this setTimeput
      setTimeout(() => {
        try {
          const conversationPanel = document.getElementById('conversation-panel-moderator');
          conversationPanel.scrollTop = conversationPanel.clientHeight;
          conversationPanel.scrollTop = conversationPanel.scrollHeight - conversationPanel.scrollTop;
        } catch (e) {
          console.log()
        }
      }, 200)
    });
    const iframeStatusRef = app.database().ref(`lallucana/${this.code}/iframeStatus`)
    const statusPosterRef = app.database().ref(`lallucana/${this.code}/posterEndStatus`)
    const statusPanicPosterRef = app.database().ref(`lallucana/${this.code}/panicPosterStatus`)
    iframeStatusRef.on('value', this.checkStatusIframe)
    statusPosterRef.on('value', this.checkStatusPosterEnd)
    statusPanicPosterRef.on('value', this.checkStatusPanicPoster)
  },
  destroyed() {
    window.removeEventListener("resize", this.matchHeight);
  }
}
</script>

<style scoped>
.conversation-panel {
  margin-bottom: 20px;
  text-align: left;
  max-height: 400px;
  overflow: auto;
  width: 100%;
}

.conversation-panel .message {
  border-bottom: 1px solid #E5E5E5;
  padding: 5px 10px;
}

hr {
  height: 1px;
  border: 0;
  background: #E5E5E5;
}

.shadowPlayer {
  box-shadow: 10px 10px 17px grey;
}

.secretaryPlayerHeight {
  height: 82vh;
}

.navItem > a {
  color: black;
}

.shadowChat {
  box-shadow: 10px 10px 17px grey;
}

button {
  background-color: #5f579A;
  color: white;
}

button:hover {
  color: white;
  background-color: #5f579A;

}
</style>
